module.exports = __webpack_public_path__ + "media/images/main/map/map-2ac4e4279123e6901bb5d033991c2855.svg";